import React from 'react'
import { Paragraph, colors, BillboardText, useContainerWidth, H2, Separator } from '@fs/zion-ui'
import { i18n } from '@fs/zion-locale'
import { Link } from '@fs/zion-router'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import ancestryLogo from './images/ancestry-logo.png'
import findMyPast from './images/find-my-past.svg'
import geneanet from './images/geneanet.jpeg'
import myHeritage from './images/MH-logo-RGB.svg'

const contentSpacingSmall = css`
  width: 100%;
  padding: 64px 0;
  text-align: center;
`
const contentSpacingLarge = css`
  width: 100%;
  padding: 64px 56px 24px;
  text-align: center;
`
const partnersBlockSmall = css`
  width: 100%;
  display: inline-block;
  margin: 28px 0 24px;
  max-width: 624px;
  padding: 0 24px;
`
const partnersBlockLarge = css`
  width: 100%;
  display: inline-block;
  margin-top: 16px;
  margin-bottom: 24px;
  max-width: 700px;
`
const partnerLogosSmall = css`
  display: flex;
  flex-direction: column;
  img {
    max-width: 250px;
    width: 100%;
    margin: 0 auto;
  }
`
const partnerLogosLarge = css`
  display: flex;
  justify-content: space-around;
  max-width: 1200px;
  margin: auto;
`
const partnerLogosVerticalSpacing = css`
  margin-top: 24px;
`
const linkSpacerSmall = css`
  margin-bottom: 12px;
`
const linkSpacerLarge = css`
  display: inline-block;
  margin-inline-end: 24px;
`
const lastLinkDisplay = css`
  display: inline-block;
`
const imageSizeLG = css`
  margin-top: 12px;
  height: 40px;
`

export default function AboutPagePartners() {
  const [t] = useTranslation()
  const atWidth = useContainerWidth()

  return (
    <>
      <div css={atWidth({ default: contentSpacingSmall, xs: contentSpacingLarge })}>
        <BillboardText primaryColor={colors.green50}>
          <H2 size={atWidth({ default: 'H5', xs: 'H4' })} centered>
            {t('about.our-partners.heading', 'Global Collaboration')}
          </H2>
        </BillboardText>
        <div css={atWidth({ default: partnersBlockSmall, xs: partnersBlockLarge })}>
          {atWidth({
            default: (
              <Paragraph size="sm">
                {t(
                  'about.our-partners.body',
                  'FamilySearch is dedicated to preserving important family records and making them freely accessible online, subject to local laws. Our work is worldwide and has involved collaborations with more than 10,000 organizations in over 100 countries. FamilySearch seeks to comply with local laws at all times.'
                )}
              </Paragraph>
            ),
            xs: (
              <Paragraph>
                {t(
                  'about.our-partners.body',
                  'FamilySearch is dedicated to preserving important family records and making them freely accessible online, subject to local laws. Our work is worldwide and has involved collaborations with more than 10,000 organizations in over 100 countries. FamilySearch seeks to comply with local laws at all times.'
                )}
              </Paragraph>
            ),
          })}
        </div>
        <br />
        <div css={atWidth({ default: linkSpacerSmall, lg: linkSpacerLarge })}>
          <Paragraph size="sm">
            <Link to="/developers" linkName="about:web-app-developers" external>
              {t('about.partners-developer-info.link', 'Web and app developers')}
            </Link>
          </Paragraph>
        </div>
        <div css={atWidth({ default: linkSpacerSmall, lg: linkSpacerLarge })}>
          <Paragraph size="sm">
            <Link to={`/${i18n.language}/info/archive`} linkName="about:archives" external>
              {t('about.for-archivists.link', 'Archives')}
            </Link>
          </Paragraph>
        </div>
        <div css={lastLinkDisplay}>
          <Paragraph size="sm">
            <Link
              to="https://familysearch.org/en/innovate/solutions-gallery/"
              linkName="about:solutions-gallery"
              external
            >
              {t('about.all-our-partners.link', 'Solutions Gallery')}
            </Link>
          </Paragraph>
        </div>
      </div>
      <div css={atWidth({ default: partnerLogosSmall, lg: partnerLogosLarge })}>
        <img css={atWidth({ lg: imageSizeLG })} src={ancestryLogo} alt="Ancestry Logo" />
        <Separator size={atWidth({ default: 'sm', lg: 'hide' })} />
        <img css={atWidth({ default: partnerLogosVerticalSpacing, lg: '' })} src={myHeritage} alt="My Heritage Logo" />
        <Separator size={atWidth({ default: 'sm', lg: 'hide' })} />
        <img css={atWidth({ default: partnerLogosVerticalSpacing, lg: '' })} src={findMyPast} alt="Find My Past Logo" />
        <Separator size={atWidth({ default: 'sm', lg: 'hide' })} />
        <img css={atWidth({ lg: imageSizeLG })} src={geneanet} alt="geneanet Logo" />
      </div>
      <Separator size={atWidth({ default: 'xl', lg: 'md' })} />
    </>
  )
}
